import {
  Component,
  OnInit,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core'
import { ROUTES } from '../../constants/routes'
import { RouteService } from '../../services/route.service'
import { TranslationService } from '../../services/translation.service'

@Component({
  selector: 'app-liability-disclaimer',
  imports: [],
  templateUrl: './liability-disclaimer.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './liability-disclaimer.component.scss',
})
export class LiabilityDisclaimerComponent implements OnInit {
  routeService = inject(RouteService)
  translationService = inject(TranslationService)

  async ngOnInit(): Promise<void> {
    const currentRoute = this.routeService.getUserRoutes(
      ROUTES.VITE_MARKETPLACE.title,
      ROUTES.LIABILITY_DISCLAIMER.path,
    )
    this.routeService.setRoute(currentRoute)
  }
}
